import _orderBy from 'lodash/orderBy'

/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getBoardById = state => id => state.boards.find(board => board.id === id)

/**
 * @param   {object} state
 * @param   {object} getters
 * @param   {number} boardId
 *
 * @returns {object}
 */
const getBoardPreviewOption = (state, getters) => boardId => {
  const styles = getters.getStylesByBoardId(boardId)

  if (styles.length > 0) {
    for (const style of styles) {
      const options = getters.getOptionsByStyleId(style.id)

      if (options.length > 0 && options[0].assets_file) {
        return options[0]
      }
    }
  }

  return null
}

/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getBoardsByProjectId = state => id =>
  _orderBy(
    state.boards.filter(board => board.project_id === id),
    'index'
  )

/**
 * @type {object}
 */
const getters = {
  getBoardById,
  getBoardsByProjectId,
  getBoardPreviewOption
}

export default getters
